<template>
<v-container class="mb-12 main--text">
  <v-row class="mb-5">
        <v-col align="center" class="black--text mt-14">
            <p class="headers1 main--text"> About Us </p>
        </v-col>
    </v-row>
    <v-row justify="center" class="row">
        <v-col align="center" md="6">
          <v-img 
            style="border-radius: 20px;"
            dark
            src="@/assets/About-us.jpg"
            width="580"
          />
        </v-col>
        <v-col md="6">
            <v-card flat class="par transparent main--text">
                <p class="par2"> Dash Waste makes waste removal 
                    simple, transparent, and dependable. The South African-
                    born world first brings independent truck owners and
                    customers together through its intuitive application.
                    Small businesses, construction companies, shopping
                    centers, renovators, housing complexes, homeowners and
                    more book their truck or skip, and local service providers and
                    loading teams collect the waste for responsible disposal -
                    all tracked and recorded online. We have been in the
                    waste business since 2007.
                </p>
                <br/>
                <p style="font-weight: bold; font-size: 22px;" class="primary--text">Business details: </p>
                <p class="par2">
                  Head Office: 36 Zinfandal Rd, Blackheath, Cape Town, South Africa <br/>
                  Registration Number: 2007/008 563/07 <br/>
                  VAT Number: 463 027 9224
                </p>   
            </v-card>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'AboutUs',
  components:{
  },
  mounted(){
    scrollTo(0, 0);
  }
}

</script>

<style scoped>
.headers1{
  font-family: Avenir1;
  font-style: normal;
  font-weight: 750;
  font-size: 48px;
  line-height: 64px;
}
.par{
  font-family: Avenir3;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
}
@media screen and (max-width: 850px) {
  .row{
    display: block;
  }
  br{
    display: none;
  }
  
}
</style>

